<template>
<select
    v-model="selectedCityIdComputed"
    class="my-select ">
    <option v-for="item in cities" :key="item.ID" :value="item.ID" >{{ item.NAME }}</option>
</select>
</template>

<script>
export default {
    name: 'CitySelect',
    data : () => ({
        selectedCityId : '',
    }),
    computed : {
        cities () {
            return this.$store.state.initialData.cities.filter(city => {
                    return ~this.$store.state.initialData.shopCitiesId.indexOf(city.ID);
                });
        },
        cityText () {
            if (!this.selectedCityId) {
                return '';
            }
            let city = this.cities.find( c => c.ID == this.selectedCityId );
            return city.UF_CITY_SELECT_TEXT;
        },
      selectedCityIdComputed:
        {
          get: function() {
            if( this.cities.length )
              {
                let city=this.cities.find(o => o.ID == this.$store.state.selectedCityId);
                if( !city )
                  {
                    city=this.cities.find(o => o.ID == this.$store.state.initialData.selectedCityId);
                  }
                if( city )
                  {
                    return city.ID;
                  }
                else
                  {
                    return this.cities[ 0 ].ID;
                  }
              }
            return this.selectedCityId;
          },
          set: function ( cityId )
          {
            if(this.$root.$refs && this.$root.$refs.orderForm)
              {
                let orderForm = this.$root.$refs.orderForm;
                if(orderForm && (typeof orderForm.setCityFromSelectCity == 'function')){
                    let city = this.cities.find( c => c.ID == cityId );
                    orderForm.setCityFromSelectCity(city);
                }
              }else{
                this.selectedCityId = cityId;
                this.$store.dispatch('setSelectedCityId', {cityId : parseInt(cityId), reload : true});
            }
          }
        }
    },
    mounted () {
        if (this.cities.length) {
            let city = this.cities.find(o => o.ID == this.$store.state.initialData.selectedCityId);
            if (city) {
                this.selectedCityId = city.ID;
            }
            else {
                this.selectedCityId = this.cities[0].ID;
            }
        }
    },
}
</script>
